import { user } from "./user";
export var registration = {
  mixins: [user],
  beforeMount() {
    //adding right register methods to form

    //choose between licenseplate and qr code
    if (this.$store.state.config.should_register_with_license_plate) {
      this.licensePlateField = {
        id: "license_plate",
        label: this.$t("label.license_plate"),
        type: "text",
        required: true
      };
    } else if (!this.fieldEqualsDisplay("license_plate", "hidden")) {
      this.licensePlateField = {
        id: "license_plate",
        label: this.$t("label.license_plate"),
        type: "text",
        required: this.fieldEqualsDisplay("license_plate", "required")
      };
    }
    if (
      this.$store.state.config.should_register_with_card_barcode &&
      this.$store.state.config.allow_registration_by_anonymous_card
    ) {
      this.barcodeField = {
        id: "barcode",
        label: this.$t("label.anonymous_or_customer_card_barcode"),
        type: "text"
      };
    } else if (this.$store.state.config.allow_registration_by_anonymous_card) {
      this.barcodeField = {
        id: "anonymous_card_barcode",
        label: this.$t("label.anonymous_card_barcode"),
        type: "text"
      };
    } else if (this.$store.state.config.should_register_with_card_barcode) {
      this.barcodeField = {
        id: "customer_card_barcode",
        label: this.$t("label.customer_card_barcode"),
        type: "number"
      };
    }
    if (this.$route.params.user_data_promise) {
      this.setFromModel(this.$route.params.user_data_promise, this.models);
    }
  },

  data() {
    return {
      loading: false,
      barcodeType: null,
      validatingBarcodeLoader: false,
      validatingBarcodeSuccessMessage: "",
      validatingBarcodeErrorMessage: "",
      validatingBarcodeLoadingMessage: "",
      validatingBarcodeLoadingIcon: null,
      validatingEmailLoader: false,
      validatingEmailSuccessMessage: "",
      validatingEmailErrorMessage: "",
      validatingEmailLoadingMessage: "",
      validatingEmailLoadingIcon: null,
      validatingLicensePlateLoader: false,
      validatingLicensePlateSuccessMessage: "",
      validatingLicensePlateErrorMessage: "",
      validatingLicensePlateLoadingMessage: "",
      validatingLicensePlateLoadingIcon: null,
      models: {
        barcode: "", //TODO: not used?
        customer_card_barcode: "",
        anonymous_card_barcode: "",
        email: "",
        password: "",
        password_verification: ""
      },
      licensePlateField: {},
      barcodeField: {},
      emailField: {
        id: "email",
        label: this.$t("label.email"),
        type: "email"
      },
      passwordField: {
        id: "password",
        label: this.$t("label.password"),
        type: "password",
        showPassword: false
      },
      verifyPasswordField: {
        id: "password_verification",
        rulesetId: "password",
        label: this.$t("label.repeated_password"),
        type: "password",
        showPassword: false
      },
      rules: {
        customer_card_barcode: [v => !!v || this.$t("rules.barcode_required")],
        email: [
          v => !!v || this.$t("rules.email_required"),
          v => /.+@.+\..+/.test(v) || this.$t("rules.email_not_valid")
        ],
        password: [
          v => !!v || this.$t("rules.password_required"),
          v =>
            (v.length > 7 && /(?=.*[^a-zA-Z])(?=.*[a-zA-Z]).{8,}/.test(v)) ||
            this.$t("rules.password_validation")
        ],
        birth_date: [
          v =>
            /^(?<Day>0[1-9]|[1-2][0-9]|3[0-1])-(?<Month>0[1-9]|1[0-2])-(?<Year>19\d{2}|20\d{2})$/.test(
              v
            ) || this.$t("rules.birth_date_valid")
        ],
        barcode: [
          v =>
            !!v || this.$t("rules.anonymous_or_customer_card_barcode_required")
        ],
        anonymous_card_barcode: [
          v => !!v || this.$t("rules.anonymous_card_barcode_required")
        ],
        optional_birth_date: [
          v =>
            v == null ||
            v.length === 0 ||
            /^(?<Day>0[1-9]|[1-2][0-9]|3[0-1])-(?<Month>0[1-9]|1[0-2])-(?<Year>19\d{2}|20\d{2})$/.test(
              v
            ) ||
            this.$t("rules.birth_date_valid")
        ]
      },

      loadingShow: false,
      loadingTitle: "",
      loadingStatus: ""
    };
  },
  methods: {
    register(e) {
      e.preventDefault();
      if (!this.$refs.regform.validate()) {
        return;
      }
      this.loadingShow = true;
      this.loadingTitle = this.$t("message.registrating");
      this.loadingStatus = "busy";

      this.$store
        .dispatch("user/register", this.removeExtraKeys(this.models))
        .then(() => {
          this.loadingTitle = this.$t("success.registration_successfull");
          this.loadingStatus = "succeeded";
        })
        .catch(() => {
          this.loadingTitle = this.$t("error.registration_failed");
          this.loadingStatus = "failed";
        });
    },
    fieldEqualsDisplay(id, display) {
      return this.$store.state.config.registration_form_fields[id] === display;
    },
    removeExtraKeys(object) {
      let newObject = {};
      Object.keys(object).forEach(key => {
        if (
          object[key] === null ||
          object[key] === undefined ||
          object[key] === "" ||
          key === this.verifyPasswordField.id
        ) {
          return;
        }

        if (key === "barcode" && object["barcode"].length > 0) {
          newObject[this.barcodeType] = object["barcode"];
          return;
        }
        newObject[key] = object[key];
      });
      return newObject;
    },
    validateBarcode() {
      this.validatingBarcodeErrorMessage = "";
      this.validatingBarcodeSuccessMessage = "";
      this.validatingBarcodeLoadingIcon = null;
      let id = this.barcodeField.id;
      let value = this.models[id];
      if (value === undefined || value.length === 0) {
        return;
      }
      let type = this.getTypeById(id);
      this.loading = true;
      this.validatingBarcodeLoader = true;
      this.validatingBarcodeLoadingMessage = this.$t(
        "message.controlling_barcode"
      );
      this.$store
        .dispatch("user/validateBarcode", { type: type, value: value })
        .then(response => {
          this.validatingBarcodeLoader = false;
          this.validatingBarcodeLoadingMessage = "";
          let data = response.data;
          let found = data.found;
          let type = data.type;
          if (!found) {
            this.validatingBarcodeLoadingIcon = "mdi-cancel";
            this.validatingBarcodeErrorMessage = this.$t(
              "error.barcode_not_found"
            );
            return;
          }
          if (type === "anonymous_card") {
            this.barcodeType = "anonymous_card_barcode";
            this.validatingBarcodeLoadingIcon = "mdi-check";
            this.validatingBarcodeSuccessMessage = this.$t(
              "success.anonymous_card_found"
            );
            return;
          }
          if (type === "customer_card") {
            this.barcodeType = "customer_card_barcode";
            this.validatingBarcodeLoadingIcon = "mdi-check";
            this.validatingBarcodeSuccessMessage = this.$t(
              "success.customer_card_found"
            );
            return;
          }
        })
        .catch(error => {
          switch (error.response.status) {
            case 429:
              this.validatingBarcodeErrorMessage = this.$t(
                "error.to_many_requests"
              );
              break;
            case 500:
              this.validatingBarcodeErrorMessage = this.$t(
                "error.something_went_wrong"
              );
              break;
            default:
              this.validatingBarcodeErrorMessage = this.$t(
                "error.something_went_wrong"
              );
              break;
          }
          this.validatingBarcodeLoader = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateEmail() {
      this.validatingEmailErrorMessage = "";
      this.validatingEmailSuccessMessage = "";
      this.validatingEmailLoadingIcon = null;
      let value = this.models["email"];
      if (
        value === undefined ||
        value.length === 0 ||
        !/.+@.+\..+/.test(value)
      ) {
        return;
      }
      this.loading = true;
      this.validatingEmailLoader = true;
      this.validatingEmailLoadingMessage = this.$t("message.controlling_email");
      this.$store
        .dispatch("user/validateEmail", { email: value })
        .then(response => {
          this.validatingEmailLoader = false;
          this.validatingEmailLoadingMessage = "";
          let data = response.data;
          let used = data.used;
          if (used) {
            this.validatingEmailLoadingIcon = "mdi-cancel";
            this.validatingEmailErrorMessage = this.$t(
              "error.email_address_is_used"
            );
            return;
          }
          this.validatingEmailLoadingIcon = "mdi-check";
          this.validatingEmailSuccessMessage = this.$t(
            "success.email_address_valid"
          );
        })
        .catch(error => {
          switch (error.response.status) {
            case 429:
              this.validatingEmailErrorMessage = this.$t(
                "error.to_many_requests"
              );
              break;
            case 500:
              this.validatingEmailErrorMessage = this.$t(
                "error.something_went_wrong"
              );
              break;
            default:
              this.validatingEmailErrorMessage = this.$t(
                "error.something_went_wrong"
              );
              break;
          }
          this.validatingEmailLoader = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateLicensePlate() {
      this.validatingLicensePlateErrorMessage = "";
      this.validatingLicensePlateSuccessMessage = "";
      this.validatingLicensePlateLoadingIcon = null;
      let value = this.models["license_plate"];
      if (value === undefined || value.length === 0) {
        return;
      }
      this.loading = true;
      this.validatingLicensePlateLoader = true;
      this.validatingLicensePlateLoadingMessage = this.$t(
        "message.controlling_license_plate"
      );
      this.$store
        .dispatch("user/validateLicensePlate", { license_plate: value })
        .then(response => {
          this.validatingLicensePlateLoader = false;
          this.validatingLicensePlateLoadingMessage = "";
          let data = response.data;
          let used = data.used;
          if (used) {
            this.validatingLicensePlateLoadingIcon = "mdi-cancel";
            this.validatingLicensePlateErrorMessage = this.$t(
              "error.license_plate_is_used"
            );
            return;
          }
          this.validatingLicensePlateLoadingIcon = "mdi-check";
          this.validatingLicensePlateSuccessMessage = this.$t(
            "success.license_plate_valid"
          );
        })
        .catch(error => {
          switch (error.response.status) {
            case 429:
              this.validatingLicensePlateErrorMessage = this.$t(
                "error.to_many_requests"
              );
              break;
            case 500:
              this.validatingLicensePlateErrorMessage = this.$t(
                "error.something_went_wrong"
              );
              break;
            default:
              this.validatingLicensePlateErrorMessage = this.$t(
                "error.something_went_wrong"
              );
              break;
          }
          this.validatingLicensePlateLoader = false;
          let data = error.response.data;
          if (
            data.error !== undefined &&
            data.error === "invalid_license_plate"
          ) {
            this.validatingLicensePlateLoadingIcon = "mdi-cancel";
            this.validatingLicensePlateErrorMessage = this.$t(
              "error.invalid_license_plate"
            );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTypeById(id) {
      switch (id) {
        case "barcode":
          return "both";
        case "anonymous_card_barcode":
          return "anonymous";
        case "customer_card_barcode":
          return "customer";
      }
    },
    isFacebookRegister() {
      return (
        this.models.facebook_id !== "undefined" &&
        this.models.facebook_id !== null
      );
    }
  },

  watch: {
    loadingStatus: function(val) {
      if (val === "succeeded" || val === "failed") {
        setTimeout(() => {
          this.loadingShow = false;
          this.loadingStatus = "";
          if (val === "succeeded") {
            this.$router.push("/");
          }
        }, 2000);
      }
    }
  }
};
